import card from './card'
import contextMenu from './context-menu'
import emptyUnrated from './empty-unrated'
import partOf from './part-of'
import searchCriteria from './search-criteria'
import trends from './trends'

export default {
    card,
    contextMenu,
    emptyUnrated,
    partOf,
    searchCriteria,
    trends
}
